module.exports = __webpack_public_path__ + "images/home-dingtalk-work/shot-4-89e95a5de0da520439882f081d964670.png";